import { useEffect, useState } from "react";
import { ScanConfigType, ScanFileType } from ".";
import API from "./api";
import ScanModal from "./ScanModal";

const useScan = ( enable: boolean = true, setBlobFunction: ( file: ScanFileType, count: number ) => void ) => {
	
	const [ isWait, setIsWait ] = useState<boolean>(false);
	const [ config, setConfig ] = useState<ScanConfigType>();
	const [ showModal, setShowModal ] = useState<boolean>(false);

	useEffect( () => {
		if ( !enable && isWait ) return;
		setIsWait( true );
		API.getScanConfig()
			.then( result => {
				setConfig( result );
			})
			.finally( () => setIsWait(false) );
    // eslint-disable-next-line
	}, [ enable ] );

	const available = enable && !!config && ( !!config.scanModuleInstallUrl || !!config.scanModuleWorkUrl );

	const setBlobFunctionHandler = async ( response: ScanFileType, count: number ) => {
		setBlobFunction( response, count );
		setShowModal( false );
	};

	return {
		isWait,
		available,
		config,
		showModal,
		setShowModal,
		renderModal: () => {
			if ( !config ) return null;
			return (
				<ScanModal 
					config={config} 
					setBlobFunction={setBlobFunctionHandler} 
					onClose={ () => setShowModal(false) }
				/> 
			);
		}
	};
};

export default useScan;
